// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { Layout, PortType, RootState, SwitchType, UserType } from 'types';
import { MainControlsInterface, MapControlsInterface } from 'types/functions';
import { SystemType } from 'types/system';
import { checkDifferent, checkLayoutDifferent, clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import TimeVesselsTab from './tabs/TimeVesselsTab';

export interface TimeMenuComponentProps {
    layout: Layout;
    active: boolean;
    mode: string;
    setLayoutAction: SetLayoutAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    port: PortType;
    system: SystemType;
    switchs: SwitchType;

    mapControls: MapControlsInterface;
    user: UserType;

    mainControls: MainControlsInterface;
}

interface TimeMenuComponentState {
    layout: Layout;
    active: boolean;
    switchs: SwitchType;

    system: SystemType;
    mode: string;
}

class TimeMenu extends Component<TimeMenuComponentProps, TimeMenuComponentState> {
    constructor(props: TimeMenuComponentProps) {
        super(props);
        this.state = {
            layout: clone(props.layout),
            switchs: clone(props.switchs),
            mode: props.mode,
            active: props.active,
            system: props.system,
        };
    }

    static getDerivedStateFromProps(props: TimeMenuComponentProps, state: TimeMenuComponentState) {
        if (checkDifferent(props.switchs, state.switchs, true)) {
            return { switchs: clone(props.switchs) };
        }

        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }

        if (
            props.mode !== state.mode ||
            props.active !== state.active ||
            checkLayoutDifferent(props.layout, state.layout, ['sections.time', 'searchId'])
        ) {
            return {
                layout: clone(props.layout),
                active: props.active,
                mode: props.mode,
            };
        }

        return null;
    }

    changeTab = (tab: string) => {
        if (!this.state.layout.sections.time.menus.timeMenu.sections[tab].state) {
            return;
        }
        this.props.setLayoutAction([
            {
                action: 'UPDATE_MENU_SECTION',
                data: {
                    menu: 'timeMenu',
                    section: 'time',
                    name: tab,
                    state: true,
                    selected: true,
                },
            },
        ]);
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-smallMenu',
                    'ml-subMenu',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between border-b border-gray-300 py-3  px-2">
                    <div className="text-lg font-bold">
                        {translate(
                            Object.keys(this.state.layout.sections.time.menus.timeMenu.sections).find(
                                (key) => this.state.layout.sections.time.menus.timeMenu.sections[key].state
                            )
                        )}
                    </div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'timeMenu',
                                        section: 'time',
                                        state: !this.state.layout.sections.time.menus.timeMenu.state,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path d="M15 6l-6 6l6 6"></path>
                        </Icon>
                    </div> */}
                </div>

                <Scrollbars
                    autoHide
                    renderThumbVertical={({ style, ...props }) => (
                        <div
                            {...props}
                            style={{
                                ...style,
                                borderRadius: 5,
                                background: '#0000004a',
                                zIndex: 30, // Custom z-index
                                position: 'relative', // Required for z-index to work
                            }}
                        />
                    )}
                    className="w-full h-menu"
                >
                    <div>
                        <TimeVesselsTab active={this.state.active}></TimeVesselsTab>
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

const timemenuStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    port: state.port.port,
    mode: state.layout.mode,
    system: state.port.system,
    switchs: state.layout.switchs,
    mapControls: state.map.mapControls,
    user: state.user.user,
    mainControls: state.layout.mainControls,
});

const timemenuDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(timemenuStateToProps, timemenuDispatchToProps)(TimeMenu);
